/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  general optimizely events used in nzr
 */

export const DLC_SAVED_SEARCH_OPT_IN = 'DLC_SAVED_SEARCH_OPT_IN'
export const HIGH_INTENT_LEAD_SENT = 'HIGH_INTENT_LEAD_SENT'
export const MESSAGE_SENT_DETAIL_AGENT = 'MESSAGE_SENT_DETAIL_AGENT'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const MESSAGE_SENT_NON_CAROUSEL = 'MESSAGE_SENT_NON_CAROUSEL'
export const LEAD_SENT_FLOORPLAN = 'LEAD_SENT_FLOORPLAN'
export const HIGH_INTENT_LEAD_SENT_FLOORPLAN = 'HIGH_INTENT_LEAD_SENT_FLOORPLAN'
export const TOUR_INTENT_LEAD_SENT = 'TOUR_INTENT_LEAD_SENT'
export const TOUR_BOOKING_LEAD_SENT = 'TOUR_BOOKING_LEAD_SENT'

// Map list pagination events
export const CLICK_MAPLIST_PAGE = 'CLICK_MAPLIST_PAGE'
export const CLICK_MAPLIST_BOTTOM = 'CLICK_MAPLIST_BOTTOM'

// Categories v1
export const SHORT_TERM_CLICK_OUT = 'SHORT_TERM_CLICK_OUT'
export const SHORT_TERM_LEAD_SENT = 'SHORT_TERM_LEAD_SENT'
